export enum AnalysisId {
  BloodPressure = '0d3f297b-cf67-48f0-9a40-bfb4101a2ab6',
  BodyMassIndexMale = '35bdef46-0dc2-4ab2-813a-36794964dc2f',
  BodyMassIndexFemale = '832dabdb-7de4-45eb-9f4b-0128a349e12f',
  BodyWeight = '2a6bdd92-5de0-410d-818d-d2221aab481f',
  BodyHeight = '35321d0b-9ecf-4d03-a07b-35e76352cfa7',
  HeartRate = '6298cf02-230a-48bd-9b35-0ceb59f41225',
  WaistCircumference = '27a9366e-38b6-410f-9cb4-c0403869d54a',
  FatPercentageMale = '378c4e1e-2e69-41fd-9b5b-06ffcac30891',
  FatPercentageFemale = '7fe5ea30-eb5b-4364-bf49-68163b8aafff',
  AlcoholConsumption = '667bf34d-0494-4fac-b06d-c7dbfdf3e3ae',
  Stress = '335aace7-c714-4049-b083-fe6b93fa3fe1',
  Covid19 = '201131ed-a73c-46c3-89c8-f00c685c1c8d',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  dietTypeId = '87b94881-ca34-4017-8a4c-886f8aa99508',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  physicalActivityId = '85c0adce-e9ad-4e90-b327-7cb55410f975',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  stepsId = '64124de9-9504-4752-adb4-7aa58a71131a',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  tgHDL = 'a85e870b-3cd4-46ff-ad44-ce77e75b3475',
}
